import React from 'react';
import {
  GlobalStyles as ChordGlobalStyles,
  ThemeProvider,
  ThemeType,
} from '@royaloperahouse/chord';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import AppRouter from 'router';
import GlobalStyles from 'modules/_shared/styles/global';
import store from 'store';
import { trackWebVitals } from './metrics/web-vitals';
import { trackPageLoadTime } from './metrics/page-load-time';
import { trackTimeToFirstInteraction } from './metrics/time-to-first-interaction';
import { trackCheckoutAnalysisEvents } from './metrics/checkout-analysis';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={ThemeType.Schools}>
      <ChordGlobalStyles />
      <Provider store={store}>
        <BrowserRouter>
          <GlobalStyles />
          <AppRouter />
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

trackWebVitals();
trackPageLoadTime();
trackTimeToFirstInteraction();
trackCheckoutAnalysisEvents();
